import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import apiClient from "../common/apiClient";
import Config from "../common/Config";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";

class DesignLinerReview extends Review {
  constructor(props) {
    super(props);

    this.creationTypeNewId = 531
    this.creationTypeDuplicateId = 532;
    this.DuoId = 517
    this.TTid = 3
    this.symesId = 4
    this.TFid = 5
    this.kneeDisarticId = 6

    this.state = {
      UOM: null,
      notes: null,
      socketType: null,
      linerCreationType: null,
      baseLinerThickness: null,
      distalThickness: null,
      proximalThickness: null,
      posteriorThickness: null,
      medialThickness: null,
      highestCircumference: null,
      lengthToHighest: null,
      residualLength: null,
      totalLength: null,
      footDirection: null,
      partNumber: null,
      cadFileName: null,
      castShippedSeparately: null,
      cadFile: null,
      duplicateLinerPartNumber: null,
      newLinerPartNumber: null,
      linerQuantityDuplicate: null,
      linerQuantityNew: null,
      fillInvagination: null,
      stovepipeLiner: null,

      cartData: [],
      designLinerSuspension: [],
      shapeCreation: [],
      designLinerFabric: [],
      designLinerType: [],
      linerColor: [],
      linerDesignOptions: [],
      linerDesignOption: [],
      designTechnicianContact: [],
      currentLiners: [],
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    try {
      await super.loadData();


      let config = { headers: {} };
      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let cartData = (
        await apiClient.get("cart/" + this.props.formTypeId,
          config
        )
      ).data;

      let fieldInputConfig = {
        headers: {},
        params: {
          fieldNames: [
            "UOM",
            "amputationLevel",
            "shapeCreation",
            "notes",
            "designLinerSuspension",
            "designLinerType",
            "designLinerFabric",
            "linerColor",
            "baseLinerThickness",
            "distalThickness",
            "proximalThickness",
            "posteriorThickness",
            "medialThickness",
            "linerCreationType",
            "castShippedSeparately",
            "highestCircumference",
            "lengthToHighest",
            "residualLength",
            "totalLength",
            "linerDesignOption",
            "linerDesignOptions",
            "designTechnicianContact",
            "duplicateLinerPartNumber",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
        config.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await apiClient.get("fieldInputs?id=" + this.props.formTypeId + "&formIndex=" + this.props.formIndex,
          fieldInputConfig
        )
      ).data;

      let linerDesignOptions = (
        await apiClient.get("fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerDesignOption" },
          }
        )
      ).data;

      const cadFile = (
        await apiClient.get("cadFiles/" + this.props.formTypeId,
          config
        )
      ).data;

      this.setState({
        UOM: fieldInputs.find(
          (fi) => fi.fieldName === "UOM"
        ).fieldOptionName,
        socketType: fieldInputs.find(
          (fi) => fi.fieldName === "amputationLevel"
        ).fieldOptionId,
        shapeCreation: fieldInputs.filter(
          (fi) => fi.fieldName === "shapeCreation"
        ),
        notes: fieldInputs.find(
          (fi) => fi.fieldName === "notes"
        ).stringData,

        designLinerSuspension: fieldInputs.filter(
          (fi) => fi.fieldName === "designLinerSuspension"
        ),
        designLinerType: fieldInputs.filter(
          (fi) => fi.fieldName === "designLinerType"
        ),
        designLinerFabric: fieldInputs.filter(
          (fi) => fi.fieldName === "designLinerFabric"
        ),
        linerColor: fieldInputs.filter(
          (fi) => fi.fieldName === "linerColor"
        ),
        baseLinerThickness: fieldInputs.find(
          (fi) => fi.fieldName === "baseLinerThickness"
        ).numericData,
        distalThickness: fieldInputs.find(
          (fi) => fi.fieldName === "distalThickness"
        ).numericData,
        proximalThickness: fieldInputs.find(
          (fi) => fi.fieldName === "proximalThickness"
        ).numericData,
        posteriorThickness: fieldInputs.find(
          (fi) => fi.fieldName === "posteriorThickness"
        ).numericData,
        medialThickness: fieldInputs.find(
          (fi) => fi.fieldName === "medialThickness"
        ).numericData,
        linerCreationType: fieldInputs.find(
          (fi) => fi.fieldName === "linerCreationType"
        ).fieldOptionId ?? this.creationTypeNewId,
        castShippedSeparately: fieldInputs.find(
          (fi) => fi.fieldName === "castShippedSeparately"
        ).booleanData,
        highestCircumference: fieldInputs.find(
          (fi) => fi.fieldName === "highestCircumference"
        )?.stringData ?? null,
        lengthToHighest: fieldInputs.find(
          (fi) => fi.fieldName === "lengthToHighest"
        )?.stringData ?? null,
        residualLength: fieldInputs.find(
          (fi) => fi.fieldName === "residualLength"
        )?.stringData ?? null,
        totalLength: fieldInputs.find(
          (fi) => fi.fieldName === "totalLength"
        )?.stringData ?? null,
        designTechnicianContact: fieldInputs.filter(
          (fi) => fi.fieldName === "designTechnicianContact"
        ),
        duplicateLinerPartNumber: fieldInputs.find(
          (fi) => fi.fieldName === "duplicateLinerPartNumber"
        ).stringData,
        fillInvagination: fieldInputs.filter(
          (fi) => fi.fieldName === "linerDesignOption" && fi.fieldOptionName === "Fill Invagination"
        ),
        stovepipeLiner: fieldInputs.filter(
          (fi) => fi.fieldName === "linerDesignOption" && fi.fieldOptionName === "Stovepipe Liner"
        ),
        linerDesignOptions: linerDesignOptions,
        cadFileName: cadFile !== null ? cadFile.cadFileName : null,
      });

      config = {
        headers: {
          UniqueId: this.props.uniqueId,
        },
        params: {
          fieldNames: ["linerPromiseShipDates"],
        },
      };

      const linerPromiseShipDates = (
        await apiClient.get("fieldInputs/" + this.props.formTypeId,
          config
        )
      ).data;

      if (linerPromiseShipDates === null) {
        let linerPartNumbers = []
        cartData.forEach(cd => {
          linerPartNumbers.push({ partNumber: cd.partNumber, formIndex: cd.formIndex + "", cutoffTime: 0, sourceId: "designLiner"})
        })

        let linerShipDateConfig = {
          params: {
            linerPartNumbers: JSON.stringify(linerPartNumbers),
          },
        };

        let shippingDates = (
          await apiClient.get("linerShipDate/",
            linerShipDateConfig,
          )
        ).data;

        cartData.map(cd => {
          cd.scheduledShipDate = this.formatShipDate(shippingDates.find((sd) => sd?.partNumber === cd.partNumber) ?? "");
          return cd;
        })
      } else {
        let parsedFieldOptions = linerPromiseShipDates.map(fi => {
          if (fi?.stringData !== null) {
            fi.stringData = JSON.parse(fi.stringData);
          }
          return fi;
        });
        cartData.map(cd => {
          const cartFieldInput = parsedFieldOptions.find((fi) => fi?.stringData?.fieldInputId === cd.fieldInputId);
          cd.scheduledShipDate = cartFieldInput?.stringData?.shipDate ?? "";
          return cd;
        })
      }
      this.setState({
        cartData: cartData
      });
      
      this.squashProductsToDisplay(this.state.cartData, this.state.linerCreationType)
      
    } catch (error) {
      console.log(error)
    }
    this.setState({ isLoaded: true });
  }

  async saveData() {

    let data = [];

    this.state.cartData.forEach((cartItem, index) => {
      data.push({
        fieldName: "LinerPromiseShipDates",
        stringData: JSON.stringify({ fieldInputId: cartItem.fieldInputId, shipDate: cartItem.scheduledShipDate }),
        dataIndex: index,
      });
    });
    
    await apiClient.post("fieldInputs/" + this.props.formTypeId,
      data
    );

    return apiClient.post("orders/" + this.props.formTypeId, null);
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  generateProducts(state, addDetailClass = true) {
    return (
      <>
        {state.currentLiners.map((item, index) => {
          return (
            <div key={index} className={addDetailClass ? "detail" : ""}>
              <div className="detailContentWrapper">
                <div className="content">
                  <p>
                    {item.name}
                  </p>
                </div>
                <div className="content">
                  <span>Part Number:</span>
                  <p>
                    {item.partNumber}
                  </p>
                </div>
                <div className="content">
                  <span>Quantity:</span>
                  <p>
                    {item.quantity}
                  </p>
                </div>
                <div className="content">
                  <span>Scheduled Ship Date:</span>
                  <p style={{ alignContent: "end" }}>
                    {item.scheduledShipDate}
                  </p>
                </div>
                {state.linerCreationType === this.creationTypeDuplicateId ?
                  <>
                    <div className="content">
                      <span>Serial Number:</span>
                      <p>{state.duplicateLinerPartNumber}</p>
                    </div>
                    <div className="content">
                      <span>Amputation Side:</span>
                      <p>{state.footDirection}</p>
                    </div>
                  </>
                  : <></>}
              </div>
            </div>
          )
        })}
      </>
    )
  }

  squashProductsToDisplay(cartData, linerCreationType) {
    const liners = cartData;
    let linersToDisplay = []
    if (linerCreationType === this.creationTypeNewId) {
      const groupedLiners = Object.groupBy(liners, ({ formIndex }) => {
        return formIndex
      });
      const groupedList = Object.entries(groupedLiners).map(([key, values]) => ({
        key,
        values
      }));
      for (let i = 0; i < groupedList.length; i++) {
        groupedList[i].values.forEach(l => {
          let liner = l;
          let duplicateDesignLinerPartNumber = ""
          switch (l.partNumber) {
            case "ALL-DES-OT":
            case "ALL-DES-EO":
              duplicateDesignLinerPartNumber = "ALL-DES-DP";
              break;
            case "ALC-DES-OT":
            case "ALC-DES-EO":
              duplicateDesignLinerPartNumber = "ALC-DES-DP";
              break;
            case "ADC-DES-OT":
            case "ADC-DES-EO":
              duplicateDesignLinerPartNumber = "ADC-DES-DP";
              break;
            default:
              break;
          }
          if (duplicateDesignLinerPartNumber === "") {
            return;
          }
          const duplicateQuantity = groupedList[i].values.find(l => l.partNumber === duplicateDesignLinerPartNumber)?.quantity ?? 0;
          const impactedLiner = { ...liner }
          impactedLiner.quantity += duplicateQuantity;
          linersToDisplay.push(impactedLiner)
        })
      }
    } else {
      linersToDisplay = liners.filter(l => l.partNumber !== "DES-SETUP");
    }

    this.setState({ currentLiners: linersToDisplay });
  }
  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
    return (
      <>
        <div
          className={`reviewWrapper ${this.props.isBilateral ? "bilateralWrapper" : ""
            }`}
        >
          {!this.props.isBilateral && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormTitle
                title="Order Review"
                description=""
              />
            </div>
          )}

          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  {this.props.isBilateral && (
                    <div className="bileralName">
                      <h2>{this.props.bilateralName}</h2>
                    </div>
                  )}
                  {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.isBilateral &&
                    "(Order " + this.props.orderNumber + ") "}
                    {this.props.name}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>Patient ID:</span>
                    <p>{this.state.patientId}</p>
                  </div>
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  {this.state.soNumber &&
                      <div className="po">
                        <span>SO Number:</span>
                        <p>{this.state.soNumber}</p>
                      </div>
                    }
                </div>
              </div>
            </div>

            <div className="information">
              {this.state.linerCreationType === this.creationTypeNewId ?
                <>
                  <div className="subDetail">
                    <h3>New Liner</h3>
                    <div className="detailWrapper">
                      <div>

                        {this.state.linerCreationType === this.creationTypeNewId ?
                          <div className="detail">
                            <h3>Products</h3>
                            {this.generateProducts(this.state, false)}
                          </div>
                          :
                          <></>}

                        <div className="detail">
                          <h4>Patient Information</h4>
                          <div className="detailContentWrapper">

                            <div className="content">
                              <span>Shape Creation:</span>
                              {this.makeFieldOutput(this.state.shapeCreation)}
                            </div>
                            {this.state.cadFileName !== null ? (
                              <div className="content">
                                <span>Filename:</span>
                                <p>{this.state.cadFileName}</p>
                              </div>
                            ) : <></>}

                            <div className="content">
                              <span>Amputation Level:</span>
                              <p>{this.state.amputationLevel}</p>
                            </div>

                            <div className="content">
                              <span>Amputation Side:</span>
                              <p>{this.state.footDirection}</p>
                            </div>

                          </div>
                        </div>
                        <div className="detail">
                          <h4>Measurements</h4>
                          <div className="detailContentWrapper">
                            <div className="">
                              {this.state.highestCircumference !== null && this.state.highestCircumference !== "" ?
                                <div className="content">
                                  <span>Highest Circumference:</span>
                                  <p>
                                    {" "}
                                    {this.imageMeasurementEntry(
                                      this.state.highestCircumference,
                                      this.state.UOM
                                    )}
                                  </p>
                                </div> :
                                <div className="content">
                                  <span>Highest Circumference:</span>
                                  <p>
                                    {" "}
                                    No Value Entered
                                  </p>
                                </div>}
                              {this.state.residualLength !== null && this.state.residualLength !== "" ?
                                <div className="content">
                                  <span>Residual Length:</span>
                                  <p>
                                    {this.imageMeasurementEntry(
                                      this.state.residualLength,
                                      this.state.UOM
                                    )}
                                  </p>
                                </div> :
                                <div className="content">
                                  <span>Residual Length:</span>
                                  <p>
                                    {" "}
                                    No Value Entered
                                  </p>
                                </div>}
                              {this.state.socketType === this.TTid || this.state.socketType === this.symesId ?
                                <>
                                  {this.state.totalLength !== null && this.state.totalLength !== "" ?
                                    <div className="content">
                                      <span>Total Length:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.totalLength,
                                          this.state.UOM
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Total Length:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                </> : <></>}
                              {this.state.socketType === this.TFid || this.state.socketType === this.kneeDisarticId ?
                                <>
                                  {this.state.lengthToHighest !== null && this.state.lengthToHighest !== "" ?
                                    <div className="content">
                                      <span>Length To Highest:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.lengthToHighest,
                                          this.state.UOM
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Length To Highest:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                </> : <></>}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="detail">
                          <h4>Product Information</h4>
                          <div className="detailContentWrapper">
                            <div className="content">
                              <span>Liner Type:</span>
                              {this.makeFieldOutput(this.state.designLinerSuspension)}
                            </div>
                            {this.state.designLinerSuspension[0].fieldOptionId !== this.DuoId ?
                              <>
                                <div className="content">
                                  <span>Interface Material:</span>
                                  {this.makeFieldOutput(this.state.designLinerType)}
                                </div>

                                <div className="content">
                                  <span>Fabric:</span>
                                  {this.makeFieldOutput(this.state.designLinerFabric)}
                                </div>
                                <div className="content">
                                  <span>Fabric Color:</span>
                                  {this.makeFieldOutput(this.state.linerColor)}
                                </div>
                              </> : <></>}
                          </div>
                        </div>

                        <div className="detail">
                          <h4>Requested Starting Thickness</h4>
                          <div className="detailContentWrapper">
                            <div className="">
                              {this.state.baseLinerThickness !== null && this.state.baseLinerThickness !== "" ?
                                <div className="content">
                                  <span>Base Liner Thickness:</span>
                                  <p>
                                    {" "}
                                    {this.imageMeasurementEntry(
                                      this.state.baseLinerThickness,
                                      "mm"
                                    )}
                                  </p>
                                </div> :
                                <div className="content">
                                  <span>Base Liner Thickness:</span>
                                  <p>
                                    {" "}
                                    No Value Entered
                                  </p>
                                </div>}
                              {this.state.distalThickness !== null && this.state.distalThickness !== "" ?
                                <div className="content">
                                  <span>Distal Thickness:</span>
                                  <p>
                                    {" "}
                                    {this.imageMeasurementEntry(
                                      this.state.distalThickness,
                                      "mm"
                                    )}
                                  </p>
                                </div> :
                                <div className="content">
                                  <span>Distal Thickness:</span>
                                  <p>
                                    {" "}
                                    No Value Entered
                                  </p>
                                </div>}
                              {this.state.proximalThickness !== null && this.state.proximalThickness !== "" ?
                                <div className="content">
                                  <span>Proximal Thickness:</span>
                                  <p>
                                    {this.imageMeasurementEntry(
                                      this.state.proximalThickness,
                                      "mm"
                                    )}
                                  </p>
                                </div> :
                                <div className="content">
                                  <span>Proximal Thickness:</span>
                                  <p>
                                    {" "}
                                    No Value Entered
                                  </p>
                                </div>}

                              {this.state.socketType === this.TTid || this.state.socketType === this.symesId ?
                                <>
                                  {this.state.posteriorThickness !== null && this.state.posteriorThickness !== "" ?
                                    <div className="content">
                                      <span>Posterior Thickness:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.posteriorThickness,
                                          "mm"
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Posterior Thickness:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                </> : <></>}

                              {this.state.socketType === this.TFid || this.state.socketType === this.kneeDisarticId ?
                                <>
                                  {this.state.medialThickness !== null && this.state.medialThickness !== "" ?
                                    <div className="content">
                                      <span>Medial Thickness:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.medialThickness,
                                          "mm"
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Medial Thickness:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                </> : <></>}

                              <div className="content">
                                {
                                  this.makeConditionalFieldOutput(
                                    "Fill Invagination",
                                    this.state.fillInvagination,
                                    "booleanData",
                                  )
                                }
                              </div>

                              <div className="content">
                                {
                                  this.makeConditionalFieldOutput(
                                    "Stovepipe Liner",
                                    this.state.stovepipeLiner,
                                    "booleanData",
                                  )
                                }
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="msgInfo ">
                    <h3>Would you like a Design Technician to contact you?</h3>
                    {this.makeFieldOutput(this.state.designTechnicianContact)}
                  </div>
                </>
                :
                <div className="subDetail">
                  <h3>Product Information</h3>
                  <div className="detailWrapper flex-wrap">
                    {this.generateProducts(this.state)}
                  </div>
                </div>
              }

              <div className="msgInfo ">
                <h3>Other Notes</h3>
                <p>{this.state.notes === null ? "none" : this.state.notes}</p>
              </div>
            </div>
            
            <div className="information">
              <h3>Customer Information</h3>
              <div className="patientInfo">
                <div className="customerInfo">
                  <div className="patientSubInfo">
                    <span>Bill to account:</span>
                    <p>{this.state.accountNumber}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Clinic:</span>
                    <p>{this.state.clinicName}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Clinician Name:</span>
                    <p>{this.state.prosthetistName}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Email Address</span>
                    <p>{this.state.email}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Phone</span>
                    <p>{this.state.phone}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom">
                    <div className="patientSubInfo">
                      <span>Shipping Address:</span>
                      <p>{this.state.shippingAddress1}</p>
                      <p>{this.state.shippingAddress2}</p>
                      <p>{this.state.city}, {this.state.stateName}</p>
                      <p>{this.state.zip}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.cartData.length > 0 ? (
              <div className="information">
                <div className="mb-3"><h3>Cart</h3></div>
                <div className="patientInfo">
                  <div className="cartSubInfo">
                    <table className="transparent-table table">
                      <thead>
                        <tr>
                          <th><span><b>Name</b></span></th>
                          <th></th>
                          <th><span><b>Part Number</b></span></th>
                          <th><span><b>Quantity</b></span></th>
                          <th className="text-right"><span><b>Price</b></span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.cartData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td lg="6" sm="1">
                                <div className="content">
                                  <p className="break-spaces">{item.name.trim()}</p>
                                  {!item.partNumber.includes("DES-SETUP") ?
                                    <>
                                      {item.serialNumber ? <p>Serial Number: {item.serialNumber}</p> : <></>}
                                      {item.footSide ? <p>Side: {item.footSide}</p> : <></>}
                                    </> : <></>}
                                </div>
                              </td>
                              <td></td>
                              <td>
                                <p>{item.partNumber}</p>
                              </td>
                              <td>
                                <p>{item.quantity}</p>
                              </td>
                              <td>
                                <p className="text-right">${this.formatPrice(item.price)}</p>
                              </td>
                            </tr>
                          )
                        })}
                        <tr>
                          <td>
                            <div>
                              <span><b>Total</b></span>
                            </div>
                          </td>
                          <td colSpan={4}>
                            <p className="text-right">
                              ${this.formatPrice(this.cartTotal(this.state.cartData))}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : <></>}

          </div >
        </div >

        {this.getNavButtons(this.props.uniqueId)}
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }

    return (
      <div className="handelButtons">
        <div className="stepBtn">
          <SecondaryButton
            text="Back"
            onClick={() =>
              this.props.handleBack(this?.props?.currentIndex - 1)
            }
            disabled={
              this.props.activeOuterStep == 0 && this.props.innerStep == 0
            }
          />
          <Button
            text="Submit"
            disabled={this.state.isLoading}
            onClick={() => {
              this.saveData();
              this.props.handleNext(this.props.currentIndex, this.props.orderIndex);
            }}
          />
        </div>
      </div>
    );
  }
}

export default DesignLinerReview;